/**
 * 현재 로그인 사용자의 권한을 로드·캐싱하는 훅.
 * 모듈 레벨에서 캐싱하므로 페이지 내에서 여러 번 호출해도 API는 1번만 호출됩니다.
 */
import { useEffect, useState } from "react";
import { api } from "./api";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

let _cached = null;
let _promise = null;

function loadPermissions() {
    if (_cached) return Promise.resolve(_cached);
    if (!_promise) {
        _promise = api.get(`${API_BASE}/employees/me/permissions`)
            .then(data => {
                _cached = Array.isArray(data) ? data : [];
                return _cached;
            })
            .catch(() => {
                _promise = null;
                return [];
            });
    }
    return _promise;
}

/** 캐시를 강제 초기화합니다 (로그아웃 시 호출). */
export function clearPermissionCache() {
    _cached = null;
    _promise = null;
}

export function useMyPermissions() {
    const [permissions, setPermissions] = useState(_cached || []);
    const [loading, setLoading]         = useState(!_cached);

    useEffect(() => {
        if (_cached) { setPermissions(_cached); setLoading(false); return; }
        setLoading(true);
        loadPermissions().then(list => {
            setPermissions(list);
            setLoading(false);
        });
    }, []);

    const isAdmin = permissions.includes("GLOBAL_ADMIN");

    /** 특정 권한 코드를 보유하고 있는지 확인. GLOBAL_ADMIN은 항상 true. */
    const hasPerm = (code) => isAdmin || permissions.includes(code);

    /**
     * 접두사로 도메인 접근 권한을 확인.
     * 예: hasPrefix("HR_") → HR_SALARY_READ 등 하나라도 있으면 true
     */
    const hasPrefix = (prefix) =>
        isAdmin || permissions.some(p => p.startsWith(prefix));

    /**
     * 여러 코드 중 하나라도 보유하면 true.
     */
    const hasAny = (...codes) =>
        isAdmin || codes.some(c => permissions.includes(c));

    return { permissions, loading, isAdmin, hasPerm, hasPrefix, hasAny };
}
